import '../sass/styles.scss';

// import './modules/modernizrCustom'
import './modules/navbarFollow';
import './modules/fixedBookNow';
import './modules/mobileMenu';
import './modules/contactForm';
import './modules/roomsModal';
import './modules/sliders';

import './modules/newsletterForm';

if($('#newsletter-modal').length) {

  // Initialize modal
  $("#newsletter-modal").iziModal({
    closeButton: true
  });
}

// Contact page
import initSingleLocationMap from './modules/contactMap';

if($('#contact-map').length) {
  initSingleLocationMap( 'contact-map', 54.991955, -7.320569, 'Bridge B&B' );
}

import makeMap from './modules/map';

if($('#locations-map').length) {
  const el = document.getElementById('locations-map');
  const slug = el.dataset.slug;
  makeMap('locations-map', slug);
}


// WEBPACK FOOTER //
// ./public/javascripts/main.js